// Import dependencies
import React, { useRef } from "react";
import emailjs from "@emailjs/browser";
import toast, { Toaster } from "react-hot-toast";
import { NavLink } from "react-router-dom";

// Import lottie components
import Gear from "../Lotties/Gear";

// Import data content
import { content } from "../assets/data/Content";

// Import components
import Helmet from "../components/Helmet/Helmet";

// Import styles
import { Container } from "reactstrap";

const Contact = () => {
  // Content
  const { contact } = content;

  const form = useRef();

  // Sending email
  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_3ln0rnk",
        "template_cdfoctr",
        form.current,
        "2-qqETxmAonGud36x"
      )
      .then(
        (result) => {
          // Clear all input field values
          form.current.reset();

          // Success toast message
          toast.success("Correo enviado satisfactoriamente");
        },
        (error) => {
          toast.error(error.text);
        }
      );
  };
  return (
    <>
      <Helmet title="Contacto">
        <section className="bg-bg_light_primary h-[100vh]">
          <Toaster />
          <div className="bg-bg_light_primary h-auto">
            {/* Title & subtitle */}
            <div className="p-8 m-0">
              <h2 className="title" data-aos="fade-right">
                {contact.title}
              </h2>

              <h4 className="subtitle" data-aos="fade-left">
                {contact.subtitle}
              </h4>
            </div>
          </div>
          <Container className="px-5 py-14">
            <form
              ref={form}
              onSubmit={sendEmail}
              className="flex-1 flex flex-col gap-5 bg-white_txt py-5 px-3 rounded-md"
            >
              <input
                type="text"
                name="from_name"
                placeholder="Nombre"
                required
                className="border border-slate-600 p-3 rounded"
              />

              <input
                type="email"
                name="user_email"
                pattern="[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{1,63}$"
                placeholder="Correo"
                required
                className="border border-slate-600 p-3 rounded"
              />

              <textarea
                name="message"
                placeholder="Mensaje"
                className="border border-slate-600 p-3 rounded h-44"
                required
              ></textarea>

              <button className="bttn self-start">Enviar</button>
            </form>
          </Container>
          {/* Return */}
          <NavLink
            to={"/home"}
            className="block fixed right-[-2rem] bottom-0 h-[120px] z-[1]"
          >
            <Gear />
          </NavLink>
        </section>
      </Helmet>
    </>
  );
};

export default Contact;
